<template>
  <div>
    <Navbar v-if="!embedded && !isScreenshot" />
    <section :style="styleObj" class="page-frame">
      <!-- <div class="bg-container">
        <img v-if="bg.bgImage && !hasSlideImage" :src="bg.bgImage" :style="bg.bgImageStyle" class="slide-background">
        <img v-if="hasSlideImage" :src="options.bgImage" :style="{opacity: options.bgOpacity}" class="slide-background">
        <img v-if="bg.overlayImage" :src="bg.overlayImage" :style="bg.overlayStyle" class="slide-overlay">
      </div> -->
      <slot />
    </section>
    <FooterHero v-if="!embedded && !isScreenshot" />
  </div>
</template>

<script>
import Navbar from '~/components/Navbar'
import FooterHero from '~/components/Footer'

export default {
  components: {
    Navbar,
    FooterHero
  },
  props: {
    theme: { default: () => { return {} } },
    options: { default: () => { return {} } },
    direction: { default: 'next' },
    embedded: {
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isScreenshot () {
      return this.$route.query.screenshot || this.$route.name === 'screenshot'
    },
    colors () {
      return this.theme.colors.colors
    },
    isDark () {
      return false // this.theme.colors && this.theme.colors.brightness === 'dark'
    },
    styleObj () {
      if (!this.colors) { return {} }

      const contrast = this.isDark ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.35)'
      const highContrast = this.isDark ? 'rgba(255,255,255,.5)' : 'rgba(0,0,0,.5)'
      const lowContrast = this.isDark ? 'rgba(255,255,255,.15)' : 'rgba(0,0,0,.15)'
      // const fontFamily = this.theme.fonts && this.theme.fonts.paragraph ? this.theme.fonts.paragraph : 'Open Sans'
      const fullContrast = this.isDark ? '#f5f5f5' : '#333'
      return {
        // backgroundColor: this.isDark ? '#eee' : '#888',
        // color: this.colors.text,
        // 'font-family': fontFamily || 'Open Sans',
        '--primary': this.colors.primary,
        '--secondary': this.colors.secondary,
        '--accent': this.colors.accent,
        '--text': this.colors.text,
        '--contrast': contrast,
        '--fullContrast': fullContrast,
        '--highContrast': highContrast,
        '--lowContrast': lowContrast
        // '--titleFont': this.theme.fonts && this.theme.fonts.title ? this.theme.fonts.title : 'Open Sans',
        // '--paraFont': fontFamily || 'Open Sans'
      }
    },
    classObj () {
      const brightness = this.isDark ? 'isDark' : 'isLight'

      return [
        brightness
      ]
    },
    bg () {
      return this.theme.background || {}
    },
    hasSlideImage () {
      return this.options.bgImage && this.options.bgImage.length > 8
    },
    overlay () {
      return this.theme.overlay || {}
    }
  }
}
</script>

<style lang="scss" scoped>
.page-frame {
  padding-top: 2.5em;
  background-color: #f3f5f9;
  padding-bottom: 2em;
}
.bg-container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0; left: 0; bottom: 0; right: 0;
  // object-fit: cover;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
  display: flex;
}

.slide-background, .slide-overlay {
  max-width: none;
  position: absolute;
  left: -20px;
  top: -20px;
  right: -20px;
  bottom: -20px;
  width: calc(100% + 40px);
  height: calc(100% + 40px);

  object-fit: cover;
  margin: 0 auto;
  filter: blur(10px);
}

.slide-branding {
  position: fixed;
  margin: 0;
  padding: 0;
  bottom: 0em;
  left: .5em;

  img {
    margin: 0;
    padding: 0;
    opacity: .6;
  }

  svg {
    width: 3.5em;
    min-width: 85px;
    max-width: 185px;
    opacity: .7;

    .slides, .with-friends {
      fill: var(--text);
    }
  }
}
</style>
